import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";

export default function SelectCell({ getValue, row, column, table, cell }) {
	const [checked, setChecked] = useState(false);
	const hiddenColumns = table.options.meta?.hiddenColumns;
	const columnId = cell.column.id;
	const isHidden = hiddenColumns && hiddenColumns.find((item) => item.id === columnId);

	const handleChange = () => {
		const updatedChecked = !checked;
		setChecked(updatedChecked);
		table.options.meta?.updateUserData(row.original?.adminId, column.id, updatedChecked);
	};

	useEffect(() => {
		setChecked(!!getValue());
	}, [getValue]);
	
	if (isHidden) return <div className="ignore"></div>;
	return (
		<>
			<Input
				type="checkbox"
				checked={checked}
				onChange={handleChange}
				className="planscreen__checkbox m-0"
			/>
		</>
	);
}
